import styled from "styled-components";
import {SideMenuItemsContainerDefaultBox} from "./side-menu-item-container.default.box";

export const SideMenuItemsContainerMrGreenBox = styled(SideMenuItemsContainerDefaultBox)`
    &::before {
        display: none;
    }
`;
